import { render, staticRenderFns } from "./VendorNewImportDialog.vue?vue&type=template&id=36ced298&scoped=true&"
import script from "./VendorNewImportDialog.vue?vue&type=script&lang=js&"
export * from "./VendorNewImportDialog.vue?vue&type=script&lang=js&"
import style0 from "./VendorNewImportDialog.vue?vue&type=style&index=0&id=36ced298&lang=scss&scoped=true&"
import style1 from "./VendorNewImportDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ced298",
  null
  
)

export default component.exports